import { Tooltip } from "@mui/material";
import { Paperclip, X } from "lucide-react";
import { StyledFileContext, StyledFileName, StyledListFiles } from "./FileContext.styles";
import { Spinner } from "../../../../components/Spinner";
import { ImageContextFile } from "../../AISupportChat.types";

type IFileContext = {
    listImgContext: ImageContextFile[]
    onDeleteImage?: (index?: number) => void
    isLoading: boolean
}

export const FileContext = ({
  listImgContext,
  onDeleteImage,
  isLoading
}: IFileContext) => {
  return (
    <StyledListFiles>
      { isLoading 
        ? (
          <Spinner size={ "1rem" }/> 
        )
        : listImgContext.map((img, index) => {
          return (
            <StyledFileContext key={ img.id }>
              <Paperclip size={ "0.875rem" }/>
              <Tooltip title={ img.name }>
                <StyledFileName>{ img.name }</StyledFileName>
              </Tooltip>
              <X
                size={ "0.875rem" }
                style={ {
                  cursor: "pointer"
                } }
                onClick={ () => onDeleteImage?.(index)
                }
              />
            </StyledFileContext>
          );
        }) }
    </StyledListFiles>
  );
};
